import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthService } from '../../../shared/service/auth.service';
import { Router } from '@angular/router';
import { CodedValueService } from '../../../shared/service/coded-value.service';

@Component({
    selector: 'ngx-header',
    styleUrls: ['./header.component.scss'],
    templateUrl: './header.component.html',
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  userPictureOnly: boolean = false;
  user: any;
  tag = 'my-context-menu';
  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];

  currentTheme = 'default';


  userMenu = [
    { title: 'Profile', value: 'userProfile', icon: 'home-outline' },
    { title: 'Account Settings', value: 'accountSettings', icon: 'settings-2-outline' },
    { title: 'Log out', value: 'logoutbtn', icon : 'power-outline' },
  ];


  userFNamefromStorage = 'usrFName';
  userLNamefromStorage = 'usrLName';
  merchantnamefromStorage = 'merchantName';


  userFullName = '';
  merchantName = '';

  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private authService: AuthService,
    private codedValueService: CodedValueService,
    private router: Router) {
    menuService.onItemClick()
      .pipe(filter(({ tag }) => tag === this.tag))
      .subscribe(
        (res: any) => {
          if (res && res.item) {
            if (res.item.value == 'userProfile') {
              this.router.navigate(['company-profile'])
            }
            if (res.item.value == 'accountSettings') {
              this.router.navigate(['company-profile/accountsettings'])
            }
            if (res.item.value == 'logoutbtn') {
              this.authService.userDigestAuth = null;
              this.authService.isUserAuthenticated.emit(false);
              this.authService.storage.clear().subscribe(
                res => {
                  this.router.navigate(['/auth/login']);
                },
                err => {
                  console.log('nout')
                }
              )
              // this.authService.storage.delete('auth').subscribe(() => {
              // });
              // this.authService.storage.delete('userDetails').subscribe(() => {
              // });
              // this.authService.storage.delete('codedvalue').subscribe(() => {
              // });
              // this.router.navigate(['/auth/login'])
            }
          }
        }
      );
  }

  ngOnInit() {
    this.getDataFromStorage();
    this.currentTheme = this.themeService.currentTheme;

    this.userService.getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe((users: any) => this.user = users.nick);

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => this.currentTheme = themeName);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.router.navigate(['/dashboard']);
    // this.menuService.navigateHome();
    return false;
  }

  getDataFromStorage() {
    this.codedValueService.getUserDetails().subscribe(
      (res: any) => {
        if (res) {
          this.userFullName = res[this.userFNamefromStorage] + " " + res[this.userLNamefromStorage]
          if (this.userFullName.includes("undefined")) {
            this.userFullName = this.userFullName.replace('undefined', '');
          }
          this.merchantName = res[this.merchantnamefromStorage]
        }
      }
    )
  }
}
